<template>
	<div class="filters-box">
		<div class="filters-box-row" :style="collapse ? 'height: 42px' : ''">
			<div class="data-picker-box">
				<el-select v-model="dateType" style="width:100px;margin-right:5px" size='small'>
					<el-option :value="0" label="下单时间"></el-option>
					<el-option :value="1" label="备货日期"></el-option>
					<el-option :value="2" label="到货日期"></el-option>
				</el-select>
				<el-date-picker
					v-model="dateValue"
					:clearable="false"
					size="small"
					type="datetimerange"
					align="right"
					style="width:405px"
					popper-class="filter-time-popper"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					:default-time="['00:00:00', '23:59:59']"
					format='yyyy-MM-dd HH:mm'
					value-format='yyyy-MM-dd HH:mm'>
				</el-date-picker>
			</div>
			<!-- <div class="data-picker-box">
				<span>备货日期：</span>
				<el-date-picker
					v-model="dateValue1"
					size="small"
					type="daterange"
					align="right"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd">
				</el-date-picker>
			</div>
			<div class="data-picker-box">
				<span>到货日期：</span>
				<el-date-picker
					v-model="dateValue2"
					size="small"
					type="daterange"
					align="right"
					unlink-panels
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="yyyy-MM-dd">
				</el-date-picker>
			</div> -->
			<div class="order-type-box">
				<span>单据类型：</span>
				<el-select v-model="ordertype" placeholder="请选择单据类型" class="order-type-select" size="small">
					<el-option
						v-for="item in options"
						:key="item.value"
						:label="item.value"
						:value="item.value">
					</el-option>
				</el-select>
			</div>
			<div class="order-NO-box">
				<span>单据编号：</span>
				<el-input v-model="ordernumber" placeholder="请输入单据编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>客户名称：</span>
				<el-input v-model="customerName" placeholder="请输入客户名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>商品编号：</span>
				<el-input v-model="pcode" placeholder="请输入商品编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>商品名称：</span>
				<el-input v-model="pname" placeholder="请输入商品名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>是否勾销：</span>
				<el-select v-model="liquidateflag"  class="order-type-select" size="small">
					<el-option value='全部' label='全部'></el-option>
					<el-option value='已勾销' label='已勾销'></el-option>
					<el-option value='未勾销' label='未勾销'></el-option>
				</el-select>
			</div>
			<div class="order-type-box">
				<span>店铺级大类：</span>
				<el-select v-model="bigcategoryid" multiple collapse-tags placeholder="请选择店铺级大类" class="order-type-select" size="small" @change="bcChange" @remove-tag="removeBigCategoryid">
					<!-- <el-option value="0" label="全部"></el-option> -->
					<template v-for="(item) in bc">
						<el-option :value="item.bc_id" :label="item.bc_name" :key="item.bc_id"/>
					</template>
				</el-select>
			</div>
			<div class="order-type-box" v-if="bigcategoryview === 1">
				<span>店铺级小类：</span>
				<el-select v-model="smallcategoryid" multiple collapse-tags placeholder="请选择店铺级小类" class="order-type-select" size="small">
					<!-- <el-option value="0" label="全部"></el-option> -->
					<template v-for="(item) in sc">
						<el-option :value="item.id" :label="item.name" :key="item.id"></el-option>
					</template>
				</el-select>
			</div>
			<div class="order-type-box">
				<span>主订单状态：</span>
				<el-select v-model="orderstatus" multiple collapse-tags placeholder="请选择订单状态" class="order-type-select" size="small">
					<!-- <el-option value="全部" label="全部"></el-option> -->
					<el-option value="待付款" label="待付款"></el-option>
					<el-option value="待接单" label="待接单"></el-option>
					<el-option value="财务审核" label="财务审核"></el-option>
					<el-option value="待发货" label="待发货"></el-option>
					<el-option value="备货中" label="备货中"></el-option>
					<el-option value="待收货" label="待收货"></el-option>
					<el-option value="已完成" label="已完成"></el-option>
					<el-option value="退单已完成" label="退单已完成"></el-option>
				</el-select>
			</div>
			<div class="order-type-box">
				<span>客户类别：</span>
				<el-select v-model="customercategoryid" filterable multiple collapse-tags class="order-type-select" size='small'>
					<!-- <el-option value="0" label="全部"></el-option> -->
					<el-option v-for="item in customList" :value="item.ccid" :label="item.ccname" :key="item.ccid"></el-option>
				</el-select>
			</div>
			<div class="order-name-box">
				<span>规格：</span>
				<el-input v-model="spec" placeholder="请输入规格名称" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>规格编号：</span>
				<el-input v-model="specCode" placeholder="请输入规格编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>客户编号：</span>
				<el-input v-model="customerCode" placeholder="请输入客户编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>第三方编号：</span>
				<el-input v-model="matchCode" placeholder="请输入第三方编号" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-type-box">
				<span>店铺名称：</span>
				<el-select v-model="shopids" class="order-type-select" collapse-tags multiple size='small'>
					<el-option v-for="item in shopList" :value="item.id" :label="item.name" :key="item.id"></el-option>
				</el-select>
			</div>
			<div class="order-type-box">
				<span>是否赠品：</span>
				<el-select v-model="giftFlag" class="order-type-select" size="small">
					<el-option value="全部" label="全部"></el-option>
					<el-option value="是" label="是"></el-option>
					<el-option value="否" label="否"></el-option>
				</el-select>
			</div>
			<div class="order-name-box">
				<span>收货人：</span>
				<el-input v-model="buyerName" placeholder="请输入收货人" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>备注：</span>
				<el-input v-model="memo" placeholder="请输入备注" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>线路：</span>
				<el-input v-model="linename" placeholder="请输入线路" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
			<div class="order-name-box">
				<span>业务员：</span>
				<el-input v-model="usernames" placeholder="请输入业务员" class="order-input" size="small" @keyup.enter.native="inputEnterHandle"></el-input>
			</div>
		</div>
		<div class="collapse-box">
			<el-button size="small" type="text" class="btn" style="color:var(--fx-primary-color);margin-left:10px" @click="handleCollapse">
				{{ collapse ? '展开' : '收起' }}
				<i class="el-icon--right" :class="collapse ? 'el-icon-arrow-down' : 'el-icon-arrow-up'" style="color:var(--fx-primary-color);"/>
			</el-button>
		</div>
	</div>
</template>
<script>
export default {
	name: 'FiltersBox',
	data () {
		return {
			buyerName: '',
			shopids: [],
			shopList: [],
			options: [
				{ value: '全部' },
				{ value: '订单' },
				{ value: '退单' }
			],
			giftFlag: '全部',
			ordertype: '全部',
			ordernumber: '',
			pname: '',
			dateValue: [],
			dateValue1: [],
			dateValue2: [],
			customerName: '',
			matchCode: '',
			customerCode: '',
			pcode: '',
			bigcategoryview: null,
			bigcategoryid: [],
			smallcategoryid: [],
			liquidateflag: '全部',
			bc: [],
			sc: [],
			orderstatus: [],
			customercategoryid: [],
			customList: [],
			spec: '',
			specCode: '',
			collapse: true,
			dateType: 0,
			memo: '',
			linename: '',
			usernames: ''
		}
	},
	created () {
		this.checkSmallCategory()
		this.getBigCategory()
		this.getCustomer()
		this.initFilters()
		this.getShopList()
	},
	methods: {
		getShopList () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/account/selectShopList`
			}).then(res => {
				this.shopList = res
			})
		},
		bcChange (value) {
			if (this.bigcategoryview === 1 && value.length > 0) {
				if (value.length > this.bigcategoryidLength) {
					this.bigcategoryidLength = value.length
				} else {
					this.smallcategoryid = []
				}
				this.getSmalCategory()
			}	else {
				this.sc = []
				this.smallcategoryid = []
				this.getSmalCategory()
			}
		},
		removeBigCategoryid () {
			this.smallcategoryid = []
		},
		getSmalCategory () {
			let params = {
				pids: this.bigcategoryid
			}
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getSmalCategory`,
				data: params
			}).then(res => {
				if (res.result) {
					this.sc = res.data
				}
			})
		},
		getBigCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/goods/getBigCategory`
			}).then(res => {
				if (res.result) {
					this.bc = res.data
				}
			})
		},
		// 是否开启小类
		checkSmallCategory () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIV}/shop/systemcenter/matchorganinfo/checkSmallCategoryIsUser`
			}).then(res => {
				this.bigcategoryview = res.bigcategoryview
			})
		},
		inputEnterHandle () {
			this.$emit('inputEnter')
		},
		getCustomer () {
			this.$store.dispatch('requestPost', {
				url: `${this.$fxBaseApi.urlQIVShop}/customerCategory/list`
			}).then(res => {
				if (res.result) {
					this.customList = res.data.childNode
				} else {
					this.$message.error(res.msg)
				}
			}).catch(error => {
				this.$message.error(error.msg)
			})
		},
		initFilters () {
			if (!this.$fxUtils.isEmptyObjSHW(this.$route.query)) {
				let Params = decodeURI(this.$route.query.throughParams)
				let throughParams = this.$fxUtils.JSONparse(Params)
				if (throughParams) {
					this.customerName = (throughParams.customerName && throughParams.customerName.value) || ''
					this.ordernumber = (throughParams.ordernumber && throughParams.ordernumber.value) || ''
					this.ordertype = (throughParams.ordertype && throughParams.ordertype.value) || '全部'
					this.giftFlag = (throughParams.giftFlag && throughParams.giftFlag.value) || '全部'
					this.liquidateflag = (throughParams.liquidateflag && throughParams.liquidateflag.value) || '全部'
					this.pname = (throughParams.pName && throughParams.pName.value) || ''
					this.pcode = (throughParams.pCode && throughParams.pCode.value) || ''
					this.orderstatus = (throughParams.orderstatus && throughParams.orderstatus.value.split(',')) || []
					this.spec = (throughParams.spec && throughParams.spec.value) || ''
					this.specCode = (throughParams.specCode && throughParams.specCode.value) || ''
					if (throughParams.startDate && throughParams.endDate) {
						let startDate = throughParams.startDate.value.split(' ')
						let endDate = throughParams.endDate.value.split(' ')
						this.dateValue = [startDate[0] + ` ${startDate[1].substring(0, 5)}`, endDate[0] + ` ${endDate[1].substring(0, 5)}`]
						this.dateType = 0
					}
					if (throughParams.startDate1 && throughParams.endDate1) {
						let startDate1 = throughParams.startDate1.value.split(' ')
						let endDate1 = throughParams.endDate1.value.split(' ')
						this.dateValue = [startDate1[0] + ` ${startDate1[1].substring(0, 5)}`, endDate1[0] + ` ${endDate1[1].substring(0, 5)}`]
						this.dateType = 1
					}
					if (throughParams.startDate2 && throughParams.endDate2) {
						let startDate2 = throughParams.startDate2.value.split(' ')
						let endDate2 = throughParams.endDate2.value.split(' ')
						this.dateValue = [startDate2[0] + ` ${startDate2[1].substring(0, 5)}`, endDate2[0] + ` ${endDate2[1].substring(0, 5)}`]
						this.dateType = 2
					}
					// console.log(startDate, startDate1, startDate2, endDate, endDate1, endDate2)
				}
			} else {
				this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
				// this.dateValue1 = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrentMonthLast()]
				// this.dateValue2 = [this.$fxUtils.getCurrentMonthFirst(), this.$fxUtils.getCurrentMonthLast()]
			}
		},
		clearSearch () {
			this.dateType = 0
			this.dateValue = [this.$fxUtils.getCurrentMonthFirst() + ' 00:00', this.$fxUtils.getCurrentMonthLast() + ' 23:59']
			this.ordertype = '全部'
			this.giftFlag = '全部'
			this.ordernumber = ''
			this.customerName = ''
			this.pcode = ''
			this.pname = ''
			this.liquidateflag = '全部'
			this.bigcategoryid = []
			this.smallcategoryid = []
			this.orderstatus = []
			this.customercategoryid = []
			this.shopids = []
			this.spec = ''
			this.specCode = ''
			this.customerCode = ''
			this.matchCode = ''
			this.buyerName = ''
			this.memo = ''
			this.linename = ''
			this.usernames = ''
		},
		getFiltersDate () {
			if (this.dateValue.length > 0) {
				return [
					{ name: 'startDate', field: 'createDate', value: `${this.dateValue[0]}:00`, 'op': 'ge', type: 'filtersParams' },
					{ name: 'endDate', field: 'createDate', value: `${this.dateValue[1]}:59`, 'op': 'le', type: 'filtersParams' }
				]
			}
		},
		getFiltersParams () {
			let filtersParams = []
			let cParams = []
			if (+this.dateValue === 0 ||
				this.dateValue === null ||
				this.dateValue === undefined) {
				filtersParams = []
			} else {
				if (this.dateType === 0) {
					filtersParams = [
						{ field: 'createDate', data: `${this.dateValue[0]}:00`, 'op': 'ge', name: '下单日期' },
						{ field: 'createDate', data: `${this.dateValue[1]}:59`, 'op': 'le', name: '下单日期' }
					]
				}
				if (this.dateType === 1) {
					filtersParams = filtersParams.concat([
						{ field: 'preparedate', data: `${this.dateValue[0]}:00`, 'op': 'ge', name: '备货日期' },
						{ field: 'preparedate', data: `${this.dateValue[1]}:59`, 'op': 'le', name: '备货日期' }
					])
				}
				if (this.dateType === 2) {
					filtersParams = filtersParams.concat([
						{ field: 'wantarrivaldate', data: `${this.dateValue[0]}:00`, 'op': 'ge', name: '到货日期' },
						{ field: 'wantarrivaldate', data: `${this.dateValue[1]}:59`, 'op': 'le', name: '到货日期' }
					])
				}
			}
			// if (+this.dateValue1 === 0 ||
			// 	this.dateValue1 === null ||
			// 	this.dateValue1 === undefined) {
			// 	filtersParams = filtersParams.concat([])
			// } else {
			// 	filtersParams = filtersParams.concat([
			// 		{ field: 'preparedate', data: `${this.dateValue1[0]} 00:00:00`, 'op': 'ge', name: '备货日期' },
			// 		{ field: 'preparedate', data: `${this.dateValue1[1]} 23:59:59`, 'op': 'le', name: '备货日期' }
			// 	])
			// }
			// if (+this.dateValue2 === 0 ||
			// 	this.dateValue2 === null ||
			// 	this.dateValue2 === undefined) {
			// 	filtersParams = filtersParams.concat([])
			// } else {
			// 	filtersParams = filtersParams.concat([
			// 		{ field: 'wantarrivaldate', data: `${this.dateValue2[0]} 00:00:00`, 'op': 'ge', name: '到货日期' },
			// 		{ field: 'wantarrivaldate', data: `${this.dateValue2[1]} 23:59:59`, 'op': 'le', name: '到货日期' }
			// 	])
			// }
			if (this.liquidateflag !== '全部') {
				let liquidateflagObj = { 'field': 'liquidateflag', 'data': this.liquidateflag, 'op': 'eq' }
				cParams.push(liquidateflagObj)
			}
			if (this.ordertype !== '全部') {
				let ordertypeObj = { 'field': 'ordertype', 'data': this.ordertype, 'op': 'eq' }
				cParams.push(ordertypeObj)
			}
			if (this.giftFlag !== '全部') {
				let giftFlag = { 'field': 'giftFlag', 'data': this.giftFlag, 'op': 'eq' }
				filtersParams.push(giftFlag)
			}
			if (this.ordernumber) {
				let orderNoObj = { 'field': 'ordernumber', 'data': this.ordernumber, 'op': 'cn' }
				cParams.push(orderNoObj)
			}
			if (this.pcode) {
				let pcodeObj = { 'field': 'pcode', 'data': this.pcode, 'op': 'cn' }
				cParams.push(pcodeObj)
			}
			if (this.buyerName) {
				let buyerNameObj = { 'field': 'buyerName', 'data': this.buyerName, 'op': 'cn' }
				cParams.push(buyerNameObj)
			}
			if (this.pname) {
				let pnameObj = { 'field': 'pname', 'data': this.pname, 'op': 'cn' }
				cParams.push(pnameObj)
			}
			if (this.customerName) {
				let customerNameObj = { 'field': 'customerName', 'data': this.customerName, 'op': 'cn' }
				cParams.push(customerNameObj)
			}
			if (this.bigcategoryid.length !== 0) {
				let bigcategoryid = { 'field': 'bigcategoryid', 'data': this.bigcategoryid.join(','), 'op': 'in' }
				filtersParams.push(bigcategoryid)
			}
			if (this.smallcategoryid.length !== 0) {
				let smallcategoryid = { 'field': 'smallcategoryid', 'data': this.smallcategoryid.join(','), 'op': 'in' }
				filtersParams.push(smallcategoryid)
			}

			if (this.shopids.length > 0) {
				let data = this.shopids.join(',')
				let shopObj = { 'field': 'shopid', 'data': data, 'op': 'in' }
				filtersParams.push(shopObj)
			}
			if (this.customerCode) {
				let customerCode = { 'field': 'customerCode', 'data': this.customerCode, 'op': 'cn' }
				filtersParams.push(customerCode)
			}
			if (this.matchCode) {
				let matchCode = { 'field': 'matchCode', 'data': this.matchCode, 'op': 'cn' }
				filtersParams.push(matchCode)
			}
			if (this.memo) {
				let memoObj = { 'field': 'memo', 'data': this.memo, 'op': 'cn' }
				filtersParams.push(memoObj)
			}
			if (this.linename) {
				let linenameObj = { 'field': 'linename', 'data': this.linename, 'op': 'cn' }
				filtersParams.push(linenameObj)
			}
			if (this.customercategoryid.length !== 0) {
				let customercategoryid = { 'field': 'customercategoryid', 'data': this.customercategoryid.join(','), 'op': 'in' }
				filtersParams.push(customercategoryid)
			}
			if (this.orderstatus.length !== 0) {
				let orderstatus = { 'field': 'orderstatus', 'data': this.orderstatus.join(','), 'op': 'in' }
				cParams.push(orderstatus)
			}
			if (this.spec) {
				let specObj = { 'field': 'spec', 'data': this.spec, 'op': 'cn' }
				cParams.push(specObj)
			}
			if (this.specCode) {
				let specCodeObj = { 'field': 'specCode', 'data': this.specCode, 'op': 'cn' }
				cParams.push(specCodeObj)
			}
			if (this.usernames) {
				let usernamesObj = { 'field': 'usernames', 'data': this.usernames, 'op': 'cn' }
				cParams.push(usernamesObj)
			}
			return {
				filtersParams,
				cParams
			}
		},
		handleCollapse () {
			this.collapse = !this.collapse
		}
	}
}
</script>
<style lang="stylus" scoped>
.filters-box {
	width:100%
	display: flex
	.filters-box-row {
		flex: 1
		display:flex
		flex-wrap: wrap
		overflow: hidden
		// margin-bottom: 10px
		&>div {
			margin-bottom: 10px
			&>span {
				display: inline-block;
				width: 105px;
				text-align: right
			}
		}
		.data-picker-box {
			// margin-right:10px
		}
		.order-type-box {
			// margin-right:10px
			.order-type-select {
				width:150px
			}
		}
		.order-NO-box, .order-name-box{
			// margin-right: 10px;
			.order-input {
				width:150px
			}
		}
	}
	.collapse-box {
		width: 80px;
		margin-left: 10px
		flex-shrink: 0
	}
}
</style>
<style lang="stylus">
.filter-time-popper {
	.el-button--text {
		display: none
	}
}
</style>
